module.exports = __webpack_public_path__ + "img/scarlets-logo-icon.9e7d369d.png";